import { Toaster as HotToast, ToastBar } from "react-hot-toast";
import { toastIcon } from "@/components/ui/toast-icons";

const Toaster: React.FC = () => {
  return (
    <HotToast
      position="bottom-left"
      gutter={8}
      containerStyle={{ bottom: 24, left: 24 }}
      toastOptions={{
        duration: 3000,
        className:
          "!bg-surface-elevation3 !text-base !text-primary !min-w-[320px] !max-w-[420px] !p-2 !rounded-xl !border-[0.5px] !border-border2 !items-start !gap-4",
        success: { icon: toastIcon.success },
        error: { icon: toastIcon.error }
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon }) => (
            <>
              {icon}
              <div className="flex min-h-7 flex-1 items-center" {...t.ariaProps}>
                {typeof t.message === "function" ? t.message(t) : t.message}
              </div>
            </>
          )}
        </ToastBar>
      )}
    </HotToast>
  );
};

export default Toaster;
